// /plastic-body — Body Plastic & Reconstructive Surgery
import { icons } from "../../components/icons";
import { plasticGroupPage } from "../plastic/shared";

export default function plasticBodyPage() {
  return plasticGroupPage({ prefix: "pb", heroImg: "hero-body.webp", icon: icons.stethoscope });
}
